<h2 class="accordion-header">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#gasMeterCollapse" aria-expanded="false" aria-controls="gasMeterCollapse">
        <app-connection-image [connectionType]="connectionType"></app-connection-image>
        <span>Gas meter</span>
    </button>
</h2>
<div id="gasMeterCollapse" class="accordion-collapse collapse" data-bs-parent="#locationMeterAccordion">
    <div class="accordion-body">
        <ng-container *ngFor="let subMeter of getMetersForConnectionType(); trackBy : trackBy">
            {{subMeter.details?.label}}
        </ng-container>
    </div>
</div>